import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodIntroduction extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { t } = this.props;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">
                    {t("Robotics_For_Good_Introduction_Title")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Introduction_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Introduction_Link")}</li>
                </ul>
              </div>
            </div>

            {/* 🌍 Robotics for Good Youth Challenge Section */}
            <div className="section-full content-inner bg-white m-t30">
              <div className="container">
                <div className="section-head style-1 text-center">
                  <h2 className="title">
                    About the Robotics for Good Youth Challenge
                  </h2>
                  <p>
                    The leading UN-based robotics competition for students aged
                    10–18, promoting innovation, sustainability, and global
                    citizenship.
                  </p>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <h4>🌍 Organized by the United Nations' ITU</h4>
                    <p>
                      The <strong>Robotics for Good Youth Challenge</strong> is
                      the leading UN-based global robotics competition,
                      organized by the International Telecommunication Union
                      (ITU) under the Robotics for Good Youth Challenge program. It invites students
                      aged 10–18 to design, build, and program robots that
                      tackle real-world challenges.
                    </p>
                    <p>
                      The <strong>2025–2026 edition</strong> focuses on{" "}
                      <strong>agriculture and food security</strong>, with
                      missions that reflect real agricultural processes and
                      sustainability goals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodIntroduction = withTranslation()(RoboticsForGoodIntroduction);
